<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sold Products Report</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/sales-summary">
          <v-icon left>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div>
          <!-- sold products -->
          <v-row dense>
            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete name="purchaseReportProductID" dense outlined v-model="record.ProductId" :items="products"
                :search-input.sync="searchProducts" label="Products" item-text="Name" item-value="id"></v-autocomplete>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete name="salesTransactionsCustomer" dense outlined v-model="record.CustomerId"
                :items="customers" label="Customer" item-text="Name" item-value="id"></v-autocomplete>
            </v-col>

            <v-col cols="12" xs="12" md="3" v-if="userLoaded && !AmayaVersion">
              <v-autocomplete autocomplete="off" dense outlined v-model="record.SoldBy" :items="users" label="Sold By"
                item-text="name" item-value="id">
              </v-autocomplete>
            </v-col>

            <!-- Category Filter -->
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete name="categoryFilter" dense outlined v-model="record.CategoryId" :items="categories"
                label="Select Category" item-text="Name" item-value="id" clearable></v-autocomplete>
            </v-col>


            <!-- Brand Filter -->
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete name="brandFilter" dense outlined v-model="record.BrandId" :items="brands"
                label="SELECT BRAND" item-text="Name" item-value="id" clearable></v-autocomplete>
            </v-col>
            
            <v-col cols="6" xs="6" md="3">
              <v-btn class="float-right" :loading="loader" @click="getReport" color="primary"><v-icon
                  left>mdi-list-box-outline</v-icon>Generate
                Report</v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" xs="6" md="9" v-if="hideTotals != 'Y'">
              <div class="style-16">Total Shop Sales: {{ totalShopSales | currency }}</div>
              <div class="style-16">Total Quantity: {{ totalSaleQty | whole-number }}</div>
              <div class="style-16" v-if="userLoaded && !AmayaVersion"> Total Outsourced Sales: {{ totalOutsourcedSales
                | currency
                }}</div>
              <div class="style-16" v-if="userLoaded && !AmayaVersion">Total Sales: {{ totalSales | currency }}</div>
              <div class="style-16" v-if="userLoaded && !AmayaVersion" style="color: red">Total Returns: {{ TotalReturns
                |
                currency }}</div>
              <div class="style-16" v-if="userLoaded && !AmayaVersion" style="font-weight: bold">Net Sales: {{ netSales
                | currency
                }}</div>

              <download-excel :data="soldProducts" :fields="fields" name="Sold Products Report">
                <v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>
            </v-col>
          </v-row>


          <v-row dense class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-text-field name="Search" v-model="search" label="Search" dense></v-text-field>
              <!-- start of table -->
              <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers" :items="soldProducts"
                :search="search">
                <!-- template -->
                <template v-slot:item.Price="{ item }">
                  {{
                    item.Price.toLocaleString()
                  }}
                </template>
                <!-- end -->

                <!-- action template -->
                <template v-slot:item.DocNum="{ item }">
                  <v-btn color="accent" text @click="openSaleDetails(item.InvoiceId)">{{ item.DocNum }}</v-btn>
                </template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.LineTotal="{ item }">
                  {{
                    item.LineTotal | currency
                  }}
                </template>
                <!-- end -->

                <!-- date template -->
                <template v-slot:item.Date="{ item }">
                  <span>{{ formatDateTime(item.Date) }}</span>
                </template>
                <!-- end -->

              </v-data-table>
            </v-col>
          </v-row>

          <v-row>
            <v-divider></v-divider>
          </v-row>

          <v-row class="subtitle-2 text--primary" v-if="userLoaded && !AmayaVersion">
            <v-col cols="12">
              <h3>Outsourced Products</h3>
            </v-col>

            <v-col cols="12" style="margin-top: -10px">
              <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="outsourcedHeaders"
                :items="outsourcedData" :search="search">

                <!-- action template -->
                <template v-slot:item.DocNum="{ item }">
                  <v-btn color="accent" text @click="openSaleDetails(item.invoice.id)">{{ item.invoice.DocNum
                  }}</v-btn>
                </template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.Quantity="{ item }">
                  <span>
                    {{
                      item.Quantity.toLocaleString()
                    }}
                  </span>
                </template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.Price="{ item }">
                  <span>
                    {{
                      item.Price | currency
                    }}
                  </span>
                </template>
                <!-- end -->
                <!-- template -->
                <template v-slot:item.LineTotal="{ item }">
                  <span>
                    {{
                      item.LineTotal | currency
                    }}
                  </span>
                </template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.Date="{ item }">
                  <span>
                    {{
                      item.Date | date
                    }}
                  </span>
                </template>
                <!-- end -->
              </v-data-table>
            </v-col>
          </v-row>
          <v-row>
            <v-divider></v-divider>
          </v-row>

          <v-row class="subtitle-2 text--primary" v-if="userLoaded && !AmayaVersion">
            <v-col cols="12">
              <h3 style="color: red">Returned Products</h3>
            </v-col>

            <v-col cols="12" style="margin-top: -30px">
              <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="returnHeaders"
                :items="returnsData" :search="search">
                <template v-slot:item.Quantity="{ item }">
                  <span style="color: red">{{ item.Quantity.toLocaleString() }}</span>
                </template>
                <template v-slot:item.Price="{ item }">
                  <span style="color: red">{{ item.Price.toLocaleString() }}</span>
                </template>
                <template v-slot:item.LineTotal="{ item }">
                  <span style="color: red">{{ item.LineTotal.toLocaleString() }}</span>
                </template>
                <template v-slot:item.Customer.Name="{ item }">
                  <span>{{ item.Customer ? item.Customer.Name : '' }}</span>
                </template>
                <template v-slot:item.product.Name="{ item }">
                  <span>{{ item.product ? item.product.Name : '' }}</span>
                </template>
                <template v-slot:item.DocDate="{ item }">
                  <span>{{ formatDateTime(item.DocDate) }}</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <!-- Sale details dialog -->
          <v-dialog v-model="detailsDialog" max-width="1150px" scrollable>
            <v-card class="details-dialog">
              <div class="details-hero">
                <div class="d-flex align-center flex-wrap px-4 py-2">
                  <v-icon color="white" class="mr-2">mdi-receipt-text-outline</v-icon>
                  <span class="white--text font-weight-medium mr-3">
                    Invoice #{{ detailsInvoice && detailsInvoice.DocNum || '—' }}
                  </span>
                  <span class="white--text text-caption mr-3" v-if="detailsInvoice && detailsInvoice.Customer">
                    <v-icon x-small color="white" class="mr-1">mdi-account-circle-outline</v-icon>
                    {{ detailsInvoice.Customer.Name }}
                  </span>
                  <span class="white--text text-caption" v-if="detailsInvoice && detailsInvoice.date">
                    <v-icon x-small color="white" class="mr-1">mdi-calendar-blank-outline</v-icon>
                    {{ detailsInvoice.date | date }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn icon dark small @click="detailsDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>

              <v-card-text class="pa-4">
                <div v-if="detailsLoading" class="text-center py-12">
                  <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                  <div class="mt-3 grey--text">Loading invoice details...</div>
                </div>

                <div v-else>
                  <v-row dense>
                    <v-col cols="12" sm="4">
                      <v-card outlined class="stat-card stat-total pa-3">
                        <div class="d-flex align-center">
                          <v-avatar color="primary lighten-5" size="40" class="mr-3">
                            <v-icon color="primary">mdi-cash-multiple</v-icon>
                          </v-avatar>
                          <div>
                            <div class="caption grey--text text-uppercase">Total Bill</div>
                            <div class="stat-value">
                              {{ (detailsInvoice && detailsInvoice.DocTotal) | currency }}
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-card outlined class="stat-card stat-paid pa-3">
                        <div class="d-flex align-center">
                          <v-avatar color="green lighten-5" size="40" class="mr-3">
                            <v-icon color="success">mdi-check-decagram</v-icon>
                          </v-avatar>
                          <div>
                            <div class="caption grey--text text-uppercase">Total Paid</div>
                            <div class="stat-value success--text">
                              {{ detailsTotalPaid | currency }}
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-card outlined class="stat-card pa-3" :class="detailsBalance > 0 ? 'stat-balance-due' : 'stat-balance-clear'">
                        <div class="d-flex align-center">
                          <v-avatar :color="detailsBalance > 0 ? 'red lighten-5' : 'grey lighten-3'" size="40" class="mr-3">
                            <v-icon :color="detailsBalance > 0 ? 'error' : 'grey darken-1'">
                              {{ detailsBalance > 0 ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline' }}
                            </v-icon>
                          </v-avatar>
                          <div>
                            <div class="caption grey--text text-uppercase">Balance</div>
                            <div class="stat-value" :class="detailsBalance > 0 ? 'error--text' : 'grey--text text--darken-1'">
                              {{ detailsBalance | currency }}
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row dense class="mt-2">
                    <v-col cols="12" class="d-flex flex-wrap" style="gap:8px">
                      <v-btn outlined small color="primary" @click="generateDetailsInvoice">
                        <v-icon left small>mdi-file-pdf-box</v-icon>Invoice PDF
                      </v-btn>
                      <v-btn outlined small color="primary" @click="generateDetailsDelivery">
                        <v-icon left small>mdi-truck-delivery-outline</v-icon>Delivery PDF
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12">
                      <v-card outlined class="info-card">
                        <div class="section-header d-flex align-center">
                          <v-icon small class="mr-2">mdi-credit-card-outline</v-icon>
                          Payments
                          <v-spacer></v-spacer>
                          <v-chip x-small color="primary" outlined>
                            {{ detailsPayments.length }} {{ detailsPayments.length === 1 ? 'entry' : 'entries' }}
                          </v-chip>
                        </div>

                        <div v-if="!detailsPayments.length" class="text-center py-6 grey--text">
                          <v-icon large color="grey lighten-1">mdi-cash-remove</v-icon>
                          <div class="caption mt-1">No payments recorded</div>
                        </div>

                        <v-list dense v-else class="py-0">
                          <div v-for="(p, index) in detailsPayments" :key="`pay-${index}`">
                            <v-list-item>
                              <v-list-item-avatar size="32" color="primary lighten-5">
                                <v-icon small color="primary">mdi-bank-outline</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-medium">
                                  {{ p.Account && p.Account.Name }}
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="p.PaymentRemarks">
                                  Ref: {{ p.PaymentRemarks }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <span class="success--text font-weight-bold">
                                  {{ p.Amount | currency }}
                                </span>
                              </v-list-item-action>
                            </v-list-item>
                            <v-divider v-if="index < detailsPayments.length - 1"></v-divider>
                          </div>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row dense class="mt-1">
                    <v-col cols="12">
                      <v-card outlined class="info-card">
                        <div class="section-header d-flex align-center">
                          <v-icon small class="mr-2">mdi-cart-outline</v-icon>
                          Sold Items
                          <v-spacer></v-spacer>
                          <v-chip x-small color="primary" outlined>
                            {{ detailsSaleRows.length }} {{ detailsSaleRows.length === 1 ? 'item' : 'items' }}
                          </v-chip>
                        </div>
                        <v-data-table
                          dense
                          light
                          :mobile-breakpoint="0"
                          :items-per-page="100"
                          :headers="detailsHeaders"
                          :items="detailsSaleRows"
                          item-key="id"
                          hide-default-footer
                          class="details-table"
                        >
                          <template v-slot:item.Name="{ item }">
                            <span>{{ item.product && item.product.Name }}</span>
                          </template>
                          <template v-slot:item.Price="{ item }">
                            <span v-if="item.Price">{{ item.Price | currency }}</span>
                          </template>
                          <template v-slot:item.LineTotal="{ item }">
                            <strong>{{ item.LineTotal | currency }}</strong>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>

                    <v-col cols="12" v-if="detailsOutsourced.length">
                      <v-card outlined class="info-card">
                        <div class="section-header">
                          <v-icon small class="mr-2">mdi-package-variant-closed</v-icon>
                          Outsourced Products
                        </div>
                        <v-data-table
                          light
                          :mobile-breakpoint="0"
                          :items-per-page="100"
                          :headers="detailsOutHeaders"
                          :items="detailsOutsourced"
                          item-key="id"
                          hide-default-footer
                          class="details-table"
                        >
                          <template v-slot:item.Price="{ item }">
                            <span v-if="item.Price">{{ item.Price | currency }}</span>
                          </template>
                          <template v-slot:item.LineTotal="{ item }">
                            <strong>{{ item.LineTotal | currency }}</strong>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>

            <pdf-preview ref="detailsPdfPreview"></pdf-preview>
          </v-dialog>
          <!-- end of sale details dialog -->
        </div>

        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
export default {
  data() {
    return {
      record: {},
      users: [],
      pageItems: 500,
      IMEI: null,
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      zeroValue: 0,
      products: [],
      customers: [],
      reportData: {},
      outsourcedData: [],
      TotalProfit: null,
      TotalQuantitySold: null,
      searchProducts: null,
      brands: [],
      categories: [],
      drivers: [],
      AmayaVersion: true,
      userLoaded: false,
      headers: [
        { text: "Invoice No.", value: "DocNum" },
        { text: "Product", value: "ProductName" },
        { text: "Qty", value: "Quantity" },
        { text: "UOM", value: "UomName" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "Customer", value: "CustomerName" },
        { text: "Payment Mode", value: "PaymentModes" },
        { text: "Owner", value: "OwnerName" },
        { text: "Sold By", value: "SoldBy" },
        { text: "Date", value: "Date" }
      ],
      outsourcedHeaders: [
        { text: "Invoice No.", value: "DocNum" },
        { text: "Item Name", value: "Name" },
        { text: "Quantity", value: "Quantity" },
        { text: "Unit", value: "UomName" },
        { text: "SellingPrice", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "Customer", value: "invoice.Customer.Name" },
        { text: "Date", value: "Date" }
      ],
      fields: {
        Customer: "CustomerName",
        Product: "ProductName",
        Quantity: "Quantity",
        BuyingPrice: "BuyingPrice",
        SellingPrice: "Price",
        TotalBuyingPrice: "TotalBuyingPrice",
        TotalSellingPrice: "LineTotal",
        Date: "Date",
      },
      soldProducts: [],
      totalSales: 0,
      totalShopSales: 0,
      totalOutsourcedSales: 0,
      totalSaleQty: 0,
      returnHeaders: [
        { text: "Customer", value: "Customer.Name" },
        { text: "Product", value: "product.Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "User", value: "user.name" },
        { text: "Date", value: "DocDate" }
      ],
      returnsData: [],
      TotalReturns: 0,
      detailsDialog: false,
      detailsLoading: false,
      detailsInvoice: {},
      detailsTotalPaid: 0,
      detailsBalance: 0,
      detailsSaleRows: [],
      detailsOutsourced: [],
      detailsPayments: [],
      detailsHeaders: [
        { text: "Item Code", value: "itemCode" },
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Unit", value: "Unit" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ],
      detailsOutHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Unit", value: "Unit" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ],
    };
  },
  computed: {
    hideTotals() {
      return localStorage.getItem("HideDebtorsTotal");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    userId() {
      return localStorage.getItem("userId");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    netSales() {
      const total = this.totalSales || 0;
      const returns = this.TotalReturns || 0;
      return total - returns;
    },
  },
  watch: {
    searchProducts(val) {
      if (val && typeof val === "string" && val.length > 1) {
        this.querySelections(val);
      }
    }
  },
  methods: {
    formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";
      const data = {
        SearchText: searchText.toString()
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
          }
        })
        .catch(() => {
          self.$store.commit("btnLoader", false);
        });
    },
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getProducts() {
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/products`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const data = this.record;
      const url = "/daily-sold-products-report";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.SalesReportData = res.ResponseData;
            self.soldProducts = res.ResponseData.SoldProducts;
            self.totalSales = res.ResponseData.TotalSales;
            self.totalOutsourcedSales = res.ResponseData.TotalOutsourcedSales;
            self.totalShopSales = res.ResponseData.TotalShopSales;
            self.totalSaleQty = res.ResponseData.TotalSaleQty;
            self.outsourcedData = res.ResponseData.OutsourcedSales;
            self.$store.commit("loader", false);
            self.loader = false;
            self.returnedProducts();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
          self.loader = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDoc() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        this.print();
      }
    },
    print() { },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.IMEI = res.ResponseData.IMEI;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    returnedProducts() {
      const data = {
        StartDate: this.record.StartDate,
        EndDate: this.record.EndDate,
        CustomerID: null
      };
      const self = this;
      const url = `/returned-products-report`;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.returnsData = res.ResponseData.AllSales;
            self.TotalReturns = res.ResponseData.TotalReturns;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    openSaleDetails(invoiceId) {
      if (!invoiceId) return;
      const self = this;
      this.detailsDialog = true;
      this.detailsLoading = true;
      this.detailsInvoice = {};
      this.detailsTotalPaid = 0;
      this.detailsBalance = 0;
      this.detailsSaleRows = [];
      this.detailsOutsourced = [];
      this.detailsPayments = [];
      this.$store
        .dispatch("get", `/sales-invoice/${invoiceId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const d = res.ResponseData || {};
            self.detailsInvoice = d.Invoice || {};
            self.detailsTotalPaid = d.TotalPaid || 0;
            self.detailsBalance = d.Balance || 0;
            self.detailsSaleRows = d.SaleRows || [];
            self.detailsOutsourced = d.OutsourcedProducts || [];
            self.detailsPayments = d.Payments || [];
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.detailsLoading = false;
        });
    },
    generateDetailsInvoice() {
      if (!this.detailsInvoice || !this.detailsInvoice.id) return;
      const isDistributor = localStorage.getItem("IsDistributor");
      const url = isDistributor == "Y"
        ? `/print-supermarket-invoice-document/14/${this.detailsInvoice.id}`
        : `/print-sale-invoice-document/14/${this.detailsInvoice.id}`;
      const self = this;
      http.get(`${host}${url}`, { responseType: "blob" }).then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(blob);
        self.$refs.detailsPdfPreview.show(fileUrl);
      });
    },
    generateDetailsDelivery() {
      if (!this.detailsInvoice || !this.detailsInvoice.id) return;
      const url = `/print-supermarket-delivery-document/10/${this.detailsInvoice.id}`;
      const self = this;
      http.get(`${host}${url}`, { responseType: "blob" }).then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(blob);
        self.$refs.detailsPdfPreview.show(fileUrl);
      });
    },
     getUserDetails() {
      const userId = localStorage.getItem("userId");
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            this.AmayaVersion = res.ResponseData.AmayaVersion == "Y" ? true : false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          this.userLoaded = true;
        })
        .catch((err) => {
          this.userLoaded = true;
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([
      this.getCustomers(),
      this.getCategories(),
      this.getBrands(),
      this.getGenSettings(),
      this.getUsers(),
      this.getUserDetails(),
    ]);
  },
};
</script>

<style lang="scss" scoped>
.details-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.details-hero {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  color: #fff;
}

.stat-card {
  border-radius: 10px !important;
  border-left: 4px solid transparent !important;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  }

  &.stat-total { border-left-color: #1976d2 !important; }
  &.stat-paid { border-left-color: #4caf50 !important; }
  &.stat-balance-due { border-left-color: #f44336 !important; }
  &.stat-balance-clear { border-left-color: #9e9e9e !important; }
}

.info-card {
  border-radius: 10px !important;
  margin-bottom: 12px;
  overflow: hidden;
}

.section-header {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #455a64;
  background: #f5f7fa;
  padding: 10px 14px;
  border-bottom: 1px solid #eceff1;
}

.details-table ::v-deep th {
  background: #fafbfc !important;
  font-weight: 600 !important;
  color: #546e7a !important;
}

.details-table ::v-deep tbody tr:hover {
  background: #f8fafc !important;
}

.details-table ::v-deep tbody td {
  font-weight: 500 !important;
  color: #37474f !important;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: #263238;
}
</style>